import { useCallback } from 'react';
import { useCalendarService } from '@mews-commander/ui';
import {
    DateFieldMode,
    FormDatePickerField,
    FormDatePickerFieldProps,
    useDateFieldTransform,
    useDateFormatPattern,
} from '@mews/framework';

export type DateFieldProps = Omit<FormDatePickerFieldProps, 'getCalendarService'> & {
    mode: DateFieldMode;
};

export const DateField = ({ mode, ...props }: DateFieldProps) => {
    const calendarService = useCalendarService();
    const getCalendarService = useCallback(() => calendarService, [calendarService]);

    const dateFormatPattern = useDateFormatPattern();
    const transform = useDateFieldTransform(mode);

    const commonProps = {
        dateFormatPattern,
        getCalendarService,
        transform,
        autoComplete: 'off',
    } satisfies Partial<FormDatePickerFieldProps>;

    return <FormDatePickerField {...commonProps} {...props} />;
};
